/** @file clipInverse: the fallback inverse re-importing one clip as it was, id kept (plan inverse C). */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { Command } from '../types/command';

/** `clip.import { doc: <clip now>, replace: true }` (or without `replace` when the clip will be gone); call it before mutating. */
export function clipInverse(clip: Clip, replace = true): Command {
  return { name: 'clip.import', input: replace ? { doc: structuredClone(clip), replace: true } : { doc: structuredClone(clip) } };
}
